import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card4.scss';

class Card4 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Módulo de aprendizagem reforça caráter educativo - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card4-home page-gradient page-gradient--yellow bg-gray" ref="card4-home">
          <section className="iniciativas-area card4-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">Módulo de aprendizagem reforça caráter educativo</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-8">
                              <p>
                                Ao longo de 2020, o{' '}
                                <a
                                  href="https://ssm-cursos.anbima.com.br/?_ga=2.65595047.846822920.1614541324-1246997442.1583920211"
                                  target="_blank"
                                >
                                  MAP (Módulo de Aprendizagem e Publicações)
                                </a>
                                &nbsp; ganhou 632 novos usuários, consolidando-se como a plataforma de cursos educativos
                                e publicações sobre as nossas atividades de autorregulação. Diversas novidades foram
                                disponibilizadas ao longo do ano, enquanto preparávamos a nova versão do MAP, lançada
                                oficialmente em janeiro de 2021.
                              </p>
                              <p>
                                O MAP faz parte do{' '}
                                <a href="https://ssm.anbima.com.br/" target="_blank">
                                  SSM
                                </a>{' '}
                                (Sistema de Supervisão de Mercados) e está no ar desde 2016 para esclarecer dúvidas das
                                instituições que seguem nossos códigos. Lá, os funcionários destas empresas, mediante um
                                cadastro, acessam conteúdos diversos sobre regras e procedimentos da autorregulação e da
                                supervisão de mercados.
                              </p>
                            </div>
                            <div className="col-4 img-center h-img">
                              <img src={images.iniciativas.card4.img1} className="img1" />
                              <img src={images.iniciativas.card4.anima1} className="anima1" />
                              <img src={images.iniciativas.card4.anima2} className="anima2" />
                            </div>
                          </div>

                          <div className="col-12">
                            <p>
                              O objetivo da atualização foi, principalmente, consolidar o MAP como um aliado das
                              instituições para a capacitação de seus colaboradores. A iniciativa reforça o caráter
                              educativo da supervisão e, consequentemente, busca reduzir o volume de penalidades.
                            </p>
                            <p>
                              A nova versão do MAP oferece mais oportunidades e formatos de treinamentos: há vídeos,
                              áudios, textos e documentos, ou seja, uma biblioteca de conteúdos multimídia com
                              esclarecimentos sobre diversos temas da autorregulação. Por meio da plataforma, também é
                              possível ter acesso direto aos nossos cursos e participar de enquetes sobre temas de
                              autorregulação.
                            </p>
                            <p>
                              Em seu núcleo principal, chamado de “Formação”, estão disponíveis treinamentos sobre as
                              regras de administração fiduciária, gestão de recursos de terceiros e distribuição de
                              fundos, além do curso Introdução à Autorregulação ANBIMA, que explica os procedimentos de
                              supervisão e a importância do compliance.
                            </p>
                            <p>
                              No início de 2021, disponibilizamos um treinamento que detalha os procedimentos para
                              cadastro e alteração de fundos.
                            </p>
                            <p>
                              <a
                                href="https://ssm-cursos.anbima.com.br/?_ga=2.65595047.846822920.1614541324-1246997442.1583920211"
                                className="button button--aylen button--yellow button--border-medium button--size-m button--round-l button--text-thick"
                              >
                                Clique aqui e conheça o MAP
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card4 };
